"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sentry = void 0;
var SentryBrowser = __importStar(require("@sentry/browser"));
// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'context' implicitly has an 'any' type.
function setContextForScope(context, scope) {
    var user = context.user, tags = context.tags, level = context.level, extras = __rest(context, ["user", "tags", "level"]);
    if (user) {
        scope.setUser(user);
    }
    if (tags) {
        scope.setTags(tags);
    }
    if (level) {
        scope.setLevel(level);
    }
    Object.keys(extras).forEach(function (key) {
        scope.setExtra(key, context[key]);
    });
}
var Sentry = {
    SentryBrowser: SentryBrowser,
    logoutHandler: null,
    isHandleling209Error: false,
    currentUser: null,
    // @ts-expect-error ts-migrate(7019) FIXME: Rest parameter 'config' implicitly has an 'any[]' ... Remove this comment to see the full error message
    init: function () {
        var _a;
        var config = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            config[_i] = arguments[_i];
        }
        return ((_a = Sentry.SentryBrowser).init.apply(_a, config));
    },
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'handler' implicitly has an 'any' type.
    setLogoutHandler: function (handler) {
        Sentry.logoutHandler = handler;
    },
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'context' implicitly has an 'any' type.
    setPersistentContext: function (context) {
        Sentry.SentryBrowser.configureScope(function (scope) {
            setContextForScope(context, scope);
        });
    },
    report: function (error, context) {
        var validError = error instanceof Error ? error : new Error(JSON.stringify(error));
        var errorCode = error.code || error.status;
        var errorContext = context || {};
        if (!(error instanceof Error)) {
            errorContext.originalErrorArtefact = error;
        }
        if (error && errorCode === 209 && Sentry.logoutHandler && !Sentry.isHandleling209Error) {
            Sentry.isHandleling209Error = true;
            var logoutHandler = Sentry.logoutHandler;
            logoutHandler(function () {
                Sentry.isHandleling209Error = false;
            });
            return;
        }
        else if (error && errorCode === 209 && Sentry.isHandleling209Error) {
            return;
        }
        console.error(error);
        if (errorContext) {
            console.info("Error context:", errorContext);
        }
        Sentry.SentryBrowser.withScope(function (scope) {
            setContextForScope(errorContext, scope);
            Sentry.SentryBrowser.captureException(validError);
        });
    }
};
exports.Sentry = Sentry;
//# sourceMappingURL=Sentry.js.map